export enum CardTypeEnum {
  EquipmentType = 'EquipmentType',
  Equipment = 'Equipment',
  Part = 'Part',
  Job = 'Job'
}
